export const ASTERISK = 'Asterisk';
export const OPTIONAL = 'Optional';
export const REQUIRED = 'Required';
